import React, { useState } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import UserManagement from "./UserManagement";
import OrganizationManagement from "./OrganizationManagement";
import "./Management.css";

const Management = ({ user }) => {
  const [activeTab, setActiveTab] = useState("users");

  const isAdmin = user?.role?.toLowerCase() === "admin";

  const titles = {
    users: {
      heading: "User Management",
      subheading:
        "Manage user accounts, roles, and permissions for your tree geotagging platform.",
    },
    organizations: {
      heading: "Organization Management",
      subheading:
        "Manage organizations, roles, and permissions for your tree geotagging platform.",
    },
  };

  return (
    <div className="management-container">
      <Box sx={{ width: "100%", p: 3 }}>
        {/* Dynamic title based on active tab */}
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          {titles[activeTab].heading}
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          {titles[activeTab].subheading}
        </Typography>

        {/* Tabs */}
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          aria-label="management tabs"
          sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
        >
          <Tab value="users" label="Users" />
          {isAdmin && <Tab value="organizations" label="Organizations" />}
        </Tabs>

        {/* Content */}
        <Box>
          {activeTab === "users" && <UserManagement user={user} />}
          {activeTab === "organizations" && isAdmin && <OrganizationManagement />}
        </Box>
      </Box>
    </div>
  );
};

export default Management;